<template>
  <v-card flat tile width="100%" class="lightPurple text-center">
    <v-container grid-list-xs>
      <v-row class="justify-space-around mr-0">
        <v-col cols="10" sm="3">
          <v-img
            :src="require('../assets/lion.png')"
            max-height="400"
            width="100%"
          />
        </v-col>
        <v-divider class="hidden-xs-only" vertical></v-divider>

        <v-col cols="12" sm="4" class="pt-10">
          <v-row class="justify-center">
            <v-card flat width="250px" class="my-10 px-4 py-2">
              <h3>Contacteaza-ne!</h3>
            </v-card></v-row
          >
          <div
            class="d-flex align-center mb-3"
            v-for="(info, i) in infoList"
            :key="'A' + i"
            cols="2"
          >
            <v-icon size="35" :color="info.color" class="ml-2 mr-3">{{
              info.icon
            }}</v-icon>
            <h4 class="white--text">{{ info.title }}</h4>
          </div>
        </v-col>
        <v-divider class="hidden-xs-only" vertical></v-divider>
        <v-col cols="12" sm="3" class="pt-10">
          <v-row class="justify-center">
            <v-card flat width="300px" class="my-10 px-4 py-2">
              <h3>Retele de socializare</h3>
            </v-card>
          </v-row>
          <v-btn
            small
            elevation="1"
            class="mr-3"
            fab
            color="white"
            v-for="(social, i) in socials"
            :key="'D' + i"
            target="_blank"
            :href="social.link"
          >
            <v-icon class="" :color="social.color">{{ social.icon }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-divider></v-divider>

    <v-card-text class="black--text my-4">
      <h3>
        © {{ new Date().getFullYear() }} - All Rights Reserved - Anastasya
        Academy
      </h3>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "Footer",

  data: () => ({
    infoList: [
      {
        icon: "mdi-phone",
        title: "0314.361.115",
        color: "white",
      },
      {
        icon: "mdi-email",
        title: "office@anastasya.ro",
        color: "white",
      },
      {
        icon: "mdi-map-marker",
        title: "Str. Sos Unirii, Nr 327, Corbeanca, Ilfov",
        color: "white",
      },
      {
        icon: "mdi-calendar",
        title: "Program: 08:00 - 19:00",
        color: "white",
      },
    ],
    socials: [
      {
        icon: "mdi-facebook",
        color: "indigo",
        link: "https://www.facebook.com/people/Anastasya-Gradinita-Scoala/100009468179608/",
      },
      {
        icon: "mdi-youtube",
        color: "red",
        link: "https://www.youtube.com/watch?v=H_FCg02XLXQ",
      },
    ],
  }),
};
</script>
<style scoped></style>
